// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroItem_wrapper__IcVAs","image":"HeroItem_image__Dnr33","subtitle":"HeroItem_subtitle__b4GGF"};